import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-fill align-items-center" }
const _hoisted_2 = { class: "flex-column" }
const _hoisted_3 = { class: "mb-0 me-2" }
const _hoisted_4 = { class: "mt-5 p-5 bg-info" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h2", { class: "mb-3" }, "Kontaktpersoner", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { class: "control-label" }, " Liste over e-mailadresser, som brugeren kan kontakte for hjælp ", -1)
const _hoisted_7 = { class: "row mt-3" }
const _hoisted_8 = { class: "col-md" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Tilføj ")
const _hoisted_10 = { class: "mt-3 text-center" }
const _hoisted_11 = {
  key: 0,
  class: "control-label"
}
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_15 = { class: "d-flex justify-content-end" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Afbryd")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_input = _resolveComponent("o-input")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_FormErrors = _resolveComponent("FormErrors")!
  const _component_Button = _resolveComponent("Button")!
  const _component_error = _resolveComponent("error")!
  const _component_Column = _resolveComponent("Column")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_VDButton = _resolveComponent("VDButton")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    draggable: false,
    modal: true,
    visible: _ctx.isVisible,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isVisible = $event)),
    style: { width: '50rem' },
    class: "appension"
  }, {
    header: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("h5", _hoisted_3, _toDisplayString(_ctx.application.applicationId
                ? "Rediger applikation"
                : "Opret applikation"), 1)
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode("div", {
        class: ["appension", { 'd-flex justify-content-between': _ctx.application }]
      }, [
        (_ctx.application.applicationId)
          ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_13, [
              _createVNode(_component_VDButton, {
                icon: "trash",
                isDisabled: (_ctx.application.roles?.length ?? 0) >= 1,
                isLoading: _ctx.deleteMutation.loading.value,
                onClick: _ctx.onDelete,
                variant: "danger"
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["isDisabled", "isLoading", "onClick"])
            ], 512)), [
              [_directive_tooltip, {
            value: 'Alle roller skal slettes først!',
            disabled: (_ctx.application.roles?.length ?? 0) < 1,
          }]
            ])
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_15, [
          _createVNode(_component_Button, {
            onClick: _ctx.hide,
            class: "link me-2"
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_VDButton, {
            onClick: _ctx.onPrimaryButton,
            icon: 'check',
            isLoading: _ctx.isLoading
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.application.applicationId ? "Gem" : "Opret"), 1)
            ]),
            _: 1
          }, 8, ["onClick", "isLoading"])
        ])
      ], 2)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_o_field, {
        variant: _ctx.v$.name.$error ? 'danger' : '',
        label: "Navn *"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_o_input, {
            ref: "nameInput",
            modelValue: _ctx.application.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.application.name = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["variant"]),
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_o_field, {
              variant: _ctx.emailValidation$.newEmail.$error ? 'danger' : ''
            }, {
              default: _withCtx(() => [
                _createVNode(_component_o_input, {
                  modelValue: _ctx.newEmail,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.newEmail = $event)),
                  class: { invalid: _ctx.emailValidation$.newEmail.$error },
                  onInput: _ctx.handleInputEmail
                }, null, 8, ["modelValue", "class", "onInput"])
              ]),
              _: 1
            }, 8, ["variant"]),
            _createVNode(_component_FormErrors, {
              errors: _ctx.emailValidation$.newEmail.$errors
            }, null, 8, ["errors"]),
            _createVNode(_component_Button, {
              class: "primary mt-2 px-4 float-right",
              onClick: _ctx.onAddEmailContacts,
              disabled: _ctx.emailValidation$.newEmail.$error || _ctx.newEmail === '',
              style: {"float":"right"}
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          (!_ctx.application.emailContacts?.length)
            ? (_openBlock(), _createBlock("label", _hoisted_11, " Ingen kontakter endnu. Tilføj en e-mail ovenfor for at udfylde listen. "))
            : _createCommentVNode("", true),
          (_ctx.application.emailContacts?.length)
            ? (_openBlock(), _createBlock(_component_DataTable, {
                key: 1,
                class: "bg-white rounded text-start",
                sortField: "emailAddress",
                responsiveLayout: "scroll",
                value: _ctx.application.emailContacts,
                selectionMode: "single"
              }, {
                empty: _withCtx(() => [
                  _createVNode(_component_error, { error: {
                title: 'Ingen e-mail',
                message: 'Der er ikke oprettet nogen e-mails endnu',
              } })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    sortable: true,
                    field: "emailAddress"
                  }, {
                    body: _withCtx(({ data }) => [
                      _createVNode("strong", null, _toDisplayString(data), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { style: {"padding-right":"unset"} }, {
                    body: _withCtx(({ data }) => [
                      _createVNode("div", _hoisted_12, [
                        _createVNode(_component_Button, {
                          class: "ms-auto appension rounded-circle inverted p-2 me-3",
                          type: "button",
                          onClick: _withModifiers(($event: any) => (_ctx.onDeleteEmailContacts(data)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'minus'] })
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}